<template>
    <SidebarItemsForTeacher
        :sections="sections"
        v-if="$page.props.auth.user.type === 'teacher'"
        :roles="$page.props.auth.user.roles"
    />
    <SidebarItemsForRelative
        :sections="sections"
        v-else-if="$page.props.auth.user.type === 'relative'"
        :students="$page.props.auth.children"
        :student_id="$page.props.auth.student_id"
    />
    <SidebarItemsForStudent :sections="sections" v-else-if="$page.props.auth.user.type === 'student'" />
</template>
<script setup>
import SidebarItemsForTeacher from '@/Shared/SidebarItemsForTeacher.vue';
import SidebarItemsForRelative from '@/Shared/SidebarItemsForRelative.vue';
import SidebarItemsForStudent from '@/Shared/SidebarItemsForStudent.vue';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const page = usePage();
const sections = computed(() => page.props.auth.app_sections);
</script>
